import { Component } from 'react';
import moment from "moment";
import jwt from "../utils/jwt";
import request from "../utils/request";

class FetchNewTokens extends Component {
    constructor(props) {
        super(props);
        if (props.cookies.get('refreshToken')) {
            request
                .post(this, "api:/auth/refresh-token", { refresh_token: props.cookies.get('refreshToken') })
                .then(resp => {
                    if (resp.access_token) {
                        const isValid = jwt.validateToken(resp.access_token);
                        if (isValid) {
                            props.cookies.set("accessToken", resp.access_token, { path: "/", expires: moment.unix(resp.expiry).toDate() });
                            props.cookies.set("refreshToken", resp.refresh_token, { path: "/" });
                        }
                    } else {
                        // Clear the refreshToken cookie and force the user to log out
                        props.cookies.remove("refreshToken", { path: "/" });
                    }
                })
                .catch(error => {
                    // Handle the error response here
                    if (error.response && error.response.data) {
                        // Clear the refreshToken cookie and force the user to log out
                        props.cookies.remove("refreshToken", { path: "/" });
                    }
                });
        }
    }

    render() {
        return null;
    }
}

export default FetchNewTokens;
